<div class="layout-container">
    <h2 class="heading-lg">Products</h2><hr>
    <p class="text-block">
        Our organization is hailed as an eminent manufacturer & supplier of CNC Machined Parts, Nylon, PC, 
        ABS polymer based Engineering Plastic components, Polypropylene based Components, etc
    </p>

    <div class="gallery-wrapper">
        <div class="image-gallery">
            <div class="image-item" *ngFor="let imag of products">
                <app-image-gallery [images]="imag"></app-image-gallery>
              </div>
        </div>
    </div>

</div>

